import { render, staticRenderFns } from "./objFolderSelected.vue?vue&type=template&id=19533ec4&"
import script from "./objFolderSelected.vue?vue&type=script&lang=ts&"
export * from "./objFolderSelected.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports